import React, { useCallback, useEffect, useState } from 'react';
import { Sidebar } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { useHistory, useLocation } from 'react-router';
import cn from 'classnames';
import EfesHeader from './EfesHeader';
import LoginWrapper from '../LoginBlock/LoginWrapper';
import ForgotPasswordWrapper from '../LoginBlock/ForgotPasswordWrapper';
import RecoverPasswordWrapper from '../LoginBlock/RecoverPasswordWrapper';
import EfesSideBarMenu from './EfesSideBarMenu';
import { nonAuthRouteTree, languageTree } from '../../helpers/menuTree/menuTree';

import styles from './responsiveContainer.module.scss';

const nonAuthSideMenu = {
  children: nonAuthRouteTree.children.concat(languageTree),
};

const ResponsiveContainer = ({ children }) => {
  const menuTree = nonAuthRouteTree;
  const menuTreeForSideBar = nonAuthSideMenu;
  const history = useHistory();
  const { pathname } = useLocation();

  const [isSidebarOpen, setSideBarOpen] = useState(false);

  useEffect(() => {
    setSideBarOpen(false);
  }, [pathname]);

  useEffect(() => {
    const mediaQuery = window.matchMedia('(min-width: 1280px)');

    function resizeHandler() {
      setSideBarOpen(false);
    }

    mediaQuery.addListener(resizeHandler);
    return () => {
      mediaQuery.removeListener(resizeHandler);
    };
  }, []);

  const handleNavigation = useCallback(
    (item) => {
      if (item.isExternal) {
        window.open(item.path, '_blank');
      } else {
        history.push(item.path);
      }
      setSideBarOpen(false);
    },
    [history],
  );

  return (
    <div id={styles.efesResponsiveContainer}>
      {isSidebarOpen && <div className={styles.overlay} />}
      <EfesHeader
        routeTree={menuTree.children}
        menuClickHandler={() => {
          setSideBarOpen(true);
        }}
        handleNavigation={handleNavigation}
      />
      <Sidebar
        className={styles.mobileSidebar}
        animation="overlay"
        onHide={() => {
          setSideBarOpen(false);
        }}
        visible={isSidebarOpen}
      >
        <EfesSideBarMenu
          routeTree={menuTreeForSideBar}
          handleNavigation={handleNavigation}
          handleClose={() => {
            setSideBarOpen(false);
          }}
        />
      </Sidebar>
      <LoginWrapper />
      <ForgotPasswordWrapper />
      <RecoverPasswordWrapper />
      <Sidebar.Pusher className={cn(isSidebarOpen && styles.preventScoll)}>
        <div className={styles.childrenContainer}>{children}</div>
      </Sidebar.Pusher>
    </div>
  );
};

ResponsiveContainer.propTypes = {
  children: PropTypes.node,
};

ResponsiveContainer.defaultProps = {
  children: null,
};

export default ResponsiveContainer;
